/* @flow */

import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import ButtonComponent from 'components/buttons/button';
import IconExclamationMarkOutlined from 'components/icons/outlined/exclamationMark';
import IntlMessageComponent from 'components/formatters/intlMessage';
import TwoFactorSetupComponent from 'app/users/twoFactorSetup';

type TwoFactorNudgeViewComponentProps = {
  dialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  completeSetup: () => void;
}

export default function TwoFactorNudgeViewComponent(props: TwoFactorNudgeViewComponentProps) {
  const action = (
    <ButtonComponent
      color="tertiary"
      variant="contained"
      onClick={props.openDialog}
    >
      <Box minWidth={120}><IntlMessageComponent id="twofactor.nudge.button" /></Box>
    </ButtonComponent>
  );

  return (
    <React.Fragment>
      <Alert action={action} icon={<IconExclamationMarkOutlined color="error" />} severity="info" style={{ backgroundColor: '#e7f9ff' }}>
        <IntlMessageComponent id="twofactor.nudge.text" />
      </Alert>

      <Dialog open={props.dialogOpen} onClose={props.closeDialog} fullWidth maxWidth="sm">
        <DialogTitle><IntlMessageComponent id="twofactor.header" /></DialogTitle>
        <DialogContent>
          <TwoFactorSetupComponent
            onComplete={props.completeSetup}
            onCancel={props.closeDialog}
            cancelLabelId="general.cancel"
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
